import createPersistedState from 'use-persisted-state'

export const m3uFilenameState = createPersistedState('m3uFilename')
export const m3uOriginalState = createPersistedState('m3uOriginal')
export const m3uDataState = createPersistedState('m3uData')
